export const specials = [
  {
    id: 's1',
    title: '年度娱乐盛典全记录',
    cover:
      'https://readdy.ai/api/search-image?query=Luxury%20award%20ceremony%20stage%20with%20warm%20golden%20and%20orange%20lighting%2C%20elegant%20editorial%20backdrop%2C%20stylized%20abstract%20visual&width=1200&height=600&seq=chigua-sp-s1&orientation=landscape',
    intro:
      '从红毯造型到舞台高光，全面记录年度娱乐盛典的每一个值得回味的瞬间。',
    reason:
      '盛典是每年娱乐圈的集中展示窗口，本专题把现场报道、造型盘点与幕后花絮整合在一起，方便你一次性回顾全部看点。',
    tag: '盛典',
    articleIds: ['a1', 'a2', 'a3'],
    views: 152000,
  },
  {
    id: 's2',
    title: '爆款综艺幕后大揭秘',
    cover:
      'https://readdy.ai/api/search-image?query=Variety%20show%20studio%20behind%20the%20scenes%20with%20warm%20orange%20stage%20lights%2C%20editorial%20abstract%20visual%2C%20clean%20composition&width=1200&height=600&seq=chigua-sp-s2&orientation=landscape',
    intro:
      '热门综艺的台前与幕后，明星嘉宾的真实状态、名场面诞生过程全在这里。',
    reason:
      '综艺的热度往往来自那些意想不到的瞬间，本专题聚焦节目幕后与出圈片段，带你看懂一档爆款是如何炼成的。',
    tag: '综艺',
    articleIds: ['a3', 'a12', 'a15'],
    views: 121000,
  },
  {
    id: 's3',
    title: '影视剧选角风云',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20casting%20studio%20with%20warm%20amber%20lamp%20light%2C%20film%20audition%20editorial%20visual%2C%20moody%20tones&width=1200&height=600&seq=chigua-sp-s3&orientation=landscape',
    intro:
      '一部剧的诞生，从选角开始。梳理热播剧的选角脉络与观众口碑的真实反馈。',
    reason:
      '选角决定了作品的气質，本专题把选角内幕、行业观察与观众讨论放在一起，呈现一部作品从无到有的关键一步。',
    tag: '影视',
    articleIds: ['a5', 'a8', 'a14'],
    views: 98000,
  },
  {
    id: 's4',
    title: '网络热梗年度盘点',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20colorful%20meme%20pattern%20with%20warm%20orange%20accents%2C%20abstract%20flat%20design%2C%20clean%20editorial%20visual&width=1200&height=600&seq=chigua-sp-s4&orientation=landscape',
    intro:
      '这一年里被反复使用的热梗、表情包与名场面，一篇看完，轻松跟上网友的聊天节奏。',
    reason:
      '热梗是网络情绪的缩影，本专题把它们整理归类，既方便回顾，也方便你在聊天中引用。',
    tag: '趣闻',
    articleIds: ['a11', 'a12', 'a14'],
    views: 134000,
  },
  {
    id: 's5',
    title: '舞台现场高光时刻',
    cover:
      'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20dramatic%20warm%20orange%20spotlights%20and%20crowd%20silhouettes%2C%20energetic%20music%20editorial%20visual&width=1200&height=600&seq=chigua-sp-s5&orientation=landscape',
    intro:
      '巡演、音乐节与现场演出，收录那些让人起鸡皮疙瘩的高光瞬间。',
    reason:
      '现场是音乐最动人的形式，本专题聚焦舞台与现场报道，记录灯光亮起时的那份感动。',
    tag: '音乐',
    articleIds: ['a4', 'a1'],
    views: 76000,
  },
  {
    id: 's6',
    title: '圈内爆料追踪档案',
    cover:
      'https://readdy.ai/api/search-image?query=Investigative%20editorial%20desk%20with%20warm%20orange%20lamp%20and%20documents%2C%20moody%20documentary%20visual%2C%20soft%20focus&width=1200&height=600&seq=chigua-sp-s6&orientation=landscape',
    intro:
      '持续追踪圈内爆料线索，梳理事件来龙去脉，用更理性的视角看待每一次热议。',
    reason:
      '爆料往往伴随着猜测，本专题把相关报道与多方回应放在一起，帮助你区分事实与传闻。',
    tag: '爆料',
    articleIds: ['a6', 'a7', 'a9', 'a10'],
    views: 143000,
  },
];